import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-610fb10e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "text-m-medium html-section",
      innerHTML: $setup.displayText
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "more-button",
      onClick: $setup.toggleShow
    }, _toDisplayString($setup.isExpanded ? "Show less" : "Show more"), 1)
  ], 64))
}